import * as Mui from "@mui/material";
import * as MuiIcons from '@mui/icons-material';
import FormInput from "../../../common/FormInput";
import { nameof } from "../../../common/ObjectUtils";
import { DamageFormTypes } from "../../Types";
import { useContext, useEffect, useMemo } from "react";
import useOperationTranslation from "../../../../hooks/useOperationTranslation";
import { ContextDamageForm } from "../../DamageFormContext";
import { AutoCompleteOption } from "../../../common/AutoComplete";
import { UseFormReturn } from "react-hook-form";
import { useHasScope } from "../../../../../../config/globalConfig";
import {GlobalContext} from "../../../../../../util/state/GlobalContextProvider";
import { ContextOperation } from "../../../../context/OperationContext";

interface Props {
    task1Fields?: DamageFormTypes.ITask1;
    onComponentDidMount?: (val: number) => void;
    formInstanceUpdate ?: UseFormReturn<DamageFormTypes.ITask1Update, any>;
}

const VehicleStatus = (props: Props) => {
    const t = useOperationTranslation();
    const damageFormContext = useContext(ContextDamageForm);
    const hasScope = useHasScope;
    const {globalData} = useContext(GlobalContext);
    const { tenant } = useContext(ContextOperation);
    
    const {msList} = useContext(ContextDamageForm)
    const mobilityStoreOptions = useMemo<AutoCompleteOption[]>(() => {

        if(!globalData?.user?.mobilityStores) {
            return [];
        }
        const msListOptions : AutoCompleteOption[] = [];
        for (var i = 0; i < globalData?.user?.mobilityStores.length; i++) {

            if (globalData?.user?.mobilityStores[i].id != 0 && globalData?.user?.mobilityStores[i].tenant === tenant) {

                msListOptions.push(
                    {
                        label: globalData?.user?.mobilityStores[i].name,
                        value: globalData?.user?.mobilityStores[i].sapId
                    }
                )
            }
        }
        return msListOptions;
    }, [msList]);

    useEffect(() => {
        props.onComponentDidMount && props.onComponentDidMount(3);
    }, []);

    const checkManagementDMSDisabled = () => {

        if (damageFormContext.task1?.formManagementLms != null && damageFormContext.task1?.formManagementLms?.id != null) {

            return damageFormContext.generalInfo?.migrated || 
            (!hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE_MANAGEMENT_DMS") && !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")) ||
            (!hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE") && hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE_MANAGEMENT_DMS") 
            && globalData?.user?.mobilityStores.filter(
                ({ sapId }: any) => sapId === damageFormContext.task1?.formManagementLms?.id
              ).length == 0);

        } else {
         return damageFormContext.generalInfo?.migrated ||
            (!hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE_MANAGEMENT_DMS") && !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE"));
        }
    }

    return(
        <Mui.Accordion>
            <Mui.AccordionSummary expandIcon={<MuiIcons.ExpandMore />}>
                <Mui.Typography>
                    {t("damageForm.details.task1.vehicleStatus.title")}
                </Mui.Typography>
            </Mui.AccordionSummary>

            <Mui.AccordionDetails>
                <Mui.Grid container spacing={3}>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("raId")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.vehicleStatus.labels.raId")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />    
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("raOwner")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.vehicleStatus.labels.raOwner")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />    
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("customerSapId")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.vehicleStatus.labels.customerSapId")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />    
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("raMail")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.vehicleStatus.labels.raMail")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("raNumber")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.vehicleStatus.labels.raNumber")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("raSectional")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.vehicleStatus.labels.raSectional")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.ITask1Update>("raDate")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            label={t("damageForm.details.task1.vehicleStatus.labels.raDate")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("renewalsSubstitutions")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.vehicleStatus.labels.rewenalsSubstitutions")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("plate")}
                            type="text"
                            label={t("damageForm.details.task1.vehicleStatus.labels.plate")}
                            formInstance={props.formInstanceUpdate}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("vin")}
                            type="text"
                            formInstance={props.formInstanceUpdate}
                            label={t("damageForm.details.task1.vehicleStatus.labels.vin")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>                    
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("vehicle")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.vehicleStatus.labels.vehicle")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("vehicleGroup")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.vehicleStatus.labels.carGroup")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("vehicleOwner")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.vehicleStatus.labels.vehicleProperty")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                                  <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("arrivalLmsId")}
                            type="select"
                            formInstance={props.formInstanceUpdate}
                            options={mobilityStoreOptions}
                            fullWidth
                            label={t("damageForm.details.task1.vehicleStatus.labels.destinationLMS")}
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>

                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("departureLmsId")}
                            type="select"
                            formInstance={props.formInstanceUpdate}
                            options={mobilityStoreOptions}
                            fullWidth
                            label={t("damageForm.details.task1.vehicleStatus.labels.startLMS")}
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>


                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("formManagementLmsId")}
                            type="select"
                            formInstance={props.formInstanceUpdate}
                            options={mobilityStoreOptions}
                            fullWidth
                            label={t("damageForm.details.task1.vehicleStatus.labels.managementLMS")}
                            disabled={checkManagementDMSDisabled()}
                        />
                    </Mui.Grid>

                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("expectedRentalEnd")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            label={t("damageForm.details.task1.vehicleStatus.labels.predictedRentEndDate")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("actualRentalEnd")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            label={t("damageForm.details.task1.vehicleStatus.labels.actualRentEndDate")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("rentalKm")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.vehicleStatus.labels.kmCounterRent")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("inspectionKm")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.vehicleStatus.labels.kmCounterControl")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("rentalFuelLevel")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.vehicleStatus.labels.tankLevelRent")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("inspectionFuelLevel")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.vehicleStatus.labels.tankLevelControl")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("rentalBatteryLevel")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.vehicleStatus.labels.batteryLevelRent")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("inspectionBatteryLevel")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.vehicleStatus.labels.batteryLevelControl")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
           
                </Mui.Grid>
            </Mui.AccordionDetails>
        </Mui.Accordion>
    )
}
export default VehicleStatus